"use client";
import { useState, MouseEvent } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTranslation } from "@/app/i18n/client";
import menuButton from "@/assets/images/icons/menuButton.svg";
import { InlineDiv } from "@/common/divs";
import routes from "@/utils/routes.json";
export const MenuButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { push } = useRouter();

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t, i18n } = useTranslation();

  return (
    <div style={{ height: "50px" }}>
      <button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <InlineDiv
          onClick={() => handleClick}
          style={{ cursor: "pointer", marginRight: "3px" }}
        >
          <Image src={menuButton.src} alt="menuButton" width={48} height={48} />
        </InlineDiv>
      </button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {routes.map((route, index) => {
          return (
            <MenuItem
              key={index}
              className="customMenuItem"
              onClick={() => {
                i18n.language == "en" ?
                  push(route["en-route"])
                : push(route["es-route"]);
              }}
            >
              {t(route.i18_tag)}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default MenuButton;
